module.exports = __webpack_public_path__ + "static/genoapay-cottonon-header-image-b153cd1a5981d19dad3f17d2e7285f1b.jpg";